module.exports = __webpack_public_path__ + "static/media/arrow-down.df0a6448.svg";